import { SvgIcon, SvgIconProps } from "@mui/material";

export const AccordianArrowIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="#323232"
        fill-rule="evenodd"
        d="m9 19 5.586-5.586c.666-.666 1-1 1-1.414 0-.414-.334-.748-1-1.414L9 5"
        clip-rule="evenodd"
      />
    </svg>{" "}
  </SvgIcon>
);
